import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "box has-background-grey-dark" }
const _hoisted_2 = { class: "content-block" }
const _hoisted_3 = { class: "dx-card responsive-paddings" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YieldFormNew = _resolveComponent("YieldFormNew")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title-wrap" }, [
      _createElementVNode("h1", { class: "title mb-1" }, "Yield Checker New")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_YieldFormNew)
      ])
    ])
  ]))
}